import { render, staticRenderFns } from "./old-promote.vue?vue&type=template&id=2d8e066c&scoped=true"
import script from "./old-promote.vue?vue&type=script&lang=ts"
export * from "./old-promote.vue?vue&type=script&lang=ts"
import style0 from "./old-promote.vue?vue&type=style&index=0&id=2d8e066c&prod&lang=scss&scoped=true"
import style1 from "./old-promote.vue?vue&type=style&index=1&id=2d8e066c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e066c",
  null
  
)

export default component.exports